export default {
  SET_SM_STORAGE_LOSSES(state, payload) {
    state.sm_storage_losses = payload || [];
  },
  SET_SM_STORAGE_LOSS(state, payload) {
    state.sm_storage_loss = payload || null;
  },
};
